// extracted by mini-css-extract-plugin
module.exports = {"loader":"GameFrame_loader__LS2iQ","inGame":"GameFrame_inGame__CUBod","iframe":"GameFrame_iframe__xop__","fade":"GameFrame_fade__fKSKI"};